const IST_TIME_ZONE = "Asia/Kolkata";

export function parseDateInput(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value).trim();
  if (!raw) {
    return null;
  }

  const hasTimezone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(raw) || raw.includes("UTC");
  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(raw);
  const normalized = hasTimezone || isDateOnly ? raw : raw.replace(" ", "T");
  const date = new Date(hasTimezone || isDateOnly ? normalized : `${normalized}Z`);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function getDateMs(value) {
  const date = parseDateInput(value);
  return date ? date.getTime() : 0;
}

export function formatDurationFromMs(milliseconds, fallback = "Awaiting call end") {
  if (!Number.isFinite(milliseconds) || milliseconds <= 0) {
    return fallback;
  }

  const totalSeconds = Math.max(1, Math.round(milliseconds / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours} hr ${minutes} min`;
  }

  if (minutes > 0) {
    return `${minutes} min ${seconds} sec`;
  }

  return `${seconds} sec`;
}

export function formatIstDateTime(value, fallback = "Awaiting data") {
  const date = parseDateInput(value);
  if (!date) {
    return fallback;
  }

  return `${new Intl.DateTimeFormat("en-IN", {
    timeZone: IST_TIME_ZONE,
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).format(date)} IST`;
}

export function formatIstDate(value, fallback = "Awaiting data") {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  const raw = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    return raw;
  }

  const date = parseDateInput(value);
  if (!date) {
    return fallback;
  }

  return new Intl.DateTimeFormat("en-IN", {
    timeZone: IST_TIME_ZONE,
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);
}
